import { Card, CardBody } from "reactstrap";
import { motion } from "framer-motion";

export default function EpoLimitNote({ limit, currentTotal }) {
    const percent = Math.min((currentTotal / limit) * 100, 100);
    const isOver = currentTotal > limit;

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
        >
            <Card
                className={`mt-3 shadow-sm ${isOver ? "border-danger" : "border-warning"
                    }`}
                style={{
                    background: "#fffbe6",
                    borderLeft: "6px solid",
                    transform: "rotate(-0.5deg)"
                }}
            >
                <CardBody>
                    <div className="d-flex align-items-center mb-2">
                        <i
                            className={`ri-pushpin-2-fill fs-18 me-2 ${isOver ? "text-danger" : "text-warning"
                                }`}
                        />
                        <strong>Employee EPO Limit</strong>
                    </div>

                    <div className="mb-2">
                        <small className="text-muted">Allowed Limit</small>
                        <div className="fw-bold">${limit.toFixed(2)}</div>
                    </div>

                    <div className="mb-2">
                        <small className="text-muted">Current EPO Total</small>
                        <div className={`fw-bold ${isOver ? "text-danger" : ""}`}>
                            ${currentTotal.toFixed(2)}
                        </div>
                    </div>

                    <div className="progress mb-2" style={{ height: "6px" }}>
                        <div
                            className={`progress-bar ${isOver ? "bg-danger" : "bg-warning"
                                }`}
                            style={{ width: `${percent}%` }}
                        />
                    </div>

                    {isOver ? (
                        <small className="text-danger fw-semibold">
                            <i className="ri-alert-line align-bottom me-1" />Exceeds allowed limit — approval required
                        </small>
                    ) : (
                        <small className="text-muted">
                            You’re within the allowed limit
                        </small>
                    )}
                </CardBody>
            </Card>
        </motion.div>
    );
}